// Modal cấu hình SỐ BÌNH LUẬN/GIỜ mỗi user được gửi (chống spam CMT).
// Vượt số này -> API trả 429, user phải đợi hết giờ mới bình luận tiếp.
// Chặn burst (vài cmt liên tiếp trong 1 phút) cố định trong code — chỉ hiển thị.
import React, { useEffect, useState } from "react";
import { Modal, InputNumber, message, Alert } from "antd";
import postApi from "../../../../api/postApi";

export default function CommentRateLimitModal({ open, onClose }) {
    const [limit, setLimit] = useState(null);
    const [range, setRange] = useState({ min: 1, max: 500 });
    const [burstLimit, setBurstLimit] = useState(null);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    // Mở modal -> tải giá trị hiện tại
    useEffect(() => {
        if (!open) return;
        (async () => {
            try {
                setLoading(true);
                const { data } = await postApi.getCommentLimit();
                const cfg = data?.data || {};
                setLimit(cfg.limit ?? null);
                setRange({ min: cfg.min ?? 1, max: cfg.max ?? 500 });
                setBurstLimit(cfg.burstLimit ?? null);
            } catch {
                message.error("Không thể tải cấu hình giới hạn bình luận");
            } finally {
                setLoading(false);
            }
        })();
    }, [open]);

    const handleSave = async () => {
        if (!Number.isInteger(limit) || limit < range.min || limit > range.max) {
            message.error(`Vui lòng nhập số từ ${range.min} đến ${range.max}`);
            return;
        }
        try {
            setSaving(true);
            await postApi.updateCommentLimit(limit);
            message.success(`Đã lưu: tối đa ${limit} bình luận/giờ`);
            onClose();
        } catch {
            message.error("Không thể lưu cấu hình");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            title="Giới hạn tốc độ bình luận (chống spam)"
            open={open}
            onOk={handleSave}
            onCancel={onClose}
            okText="Lưu"
            cancelText="Đóng"
            confirmLoading={saving}
        >
            <Alert
                type="info"
                showIcon
                className="mb-3"
                message={`Số bình luận (tính cả trả lời) tối đa mỗi người dùng gửi trong 1 giờ. Vượt quá sẽ bị chặn tới khi hết giờ. Áp dụng sau khoảng 30 giây.${
                    burstLimit ? ` Ngoài ra luôn chặn quá ${burstLimit} bình luận/phút.` : ""
                } Admin và CTV không bị giới hạn.`}
            />
            <InputNumber
                className="w-full"
                min={range.min}
                max={range.max}
                precision={0}
                value={limit}
                onChange={setLimit}
                disabled={loading}
                addonAfter="bình luận / giờ"
            />
        </Modal>
    );
}
